import { useCallback, useEffect, useMemo } from 'react';

import { useAuthentication } from '@givebacks/api';
import { useBreakPoints } from 'core/Hooks';
import {
  Outlet,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

import { useOnboardingReferrals } from '../../components/auth/hooks';
import { usePrefetchCause } from '../../hooks/queries/Core/causes';

export const JoinLayout = () => {
  const { isAuthenticated } = useAuthentication();
  const prefetchCause = usePrefetchCause();
  const { uuid, code } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { setOnboardingReferral, setOnboardingCause, useGetUserReferral } =
    useOnboardingReferrals();
  const { status } = useGetUserReferral(code);

  const [searchParams] = useSearchParams();
  const isMemberhub = searchParams.get('memberhub');
  const queryEmail = searchParams.get('email');
  const querySso = searchParams.get('sso');
  const isJoinRoute = useMatch('/join/*');
  const isReferralRoute = useMatch('/referrals/*');

  const { isMobile } = useBreakPoints();
  // Not entirely sure I wan't to remove all of this logic yet. But, isJoinRoute should be good enough in the future
  const showOneClickDrawer = useMemo(
    () => queryEmail || querySso || isJoinRoute || isReferralRoute,
    [queryEmail, querySso, isJoinRoute, isReferralRoute]
  );

  const handleOnboardingDrawer = () => {
    if (location.state || isMobile) return;
    // Currently this is pretty specific to the join page.
    // If this is going to be expanded we should create a map of the options.
    if (showOneClickDrawer) {
      navigate('/sign-up');
    }
  };
  const setCause = useCallback((uuid: string) => setOnboardingCause(uuid), [setOnboardingCause]);

  useEffect(() => {
    if (uuid) {
      prefetchCause({
        uuid,
        isMemberhub: !!isMemberhub,
        cb: !isAuthenticated ? setCause : undefined,
      });
      handleOnboardingDrawer();
    }
  }, [uuid, isAuthenticated]);

  useEffect(() => {
    if (code) {
      setOnboardingReferral(code);
      // Right now these both do the same thing, set this up so it can be expanded in future if needed.
      if (status === 'success') {
        handleOnboardingDrawer();
      } else if (status === 'error') {
        handleOnboardingDrawer();
      }
    }
  }, [code, status]);

  return <Outlet context={{}} />;
};
